<template>
  <div class="fav-box" @click="fav">
    <span class="fav">收藏</span>
    <span :class="isFav == 1 ? 'iconfont icon-buoumaotubiao44': 'iconfont icon-shoucang2'"></span>
  </div>
</template>

<script>
import {
  addCourseFav,
  addNewsFav,
  addCoursePkgFav,
  deleteCourseFav,
  deleteNewsFav,
  deleteCoursePkgFav
} from "@/api/user.js";
import { checkLogin } from "@/api/auth.js";

export default {
  data() {
    return {};
  },
  methods: {
    fav: function() {
      if (checkLogin() == undefined) {
        this.$message({
          message: '您还未登录，请先登录！',
          type: 'warning'
        });
        setTimeout(() => {
            this.$router.push('/login');
        }, 1200);
        return;
      }
      if (!this.id) {
        return;
      }
      if(!this.type){
        return;
      }
      if (this.isFav == 0) {
        if (this.type == 1) {
          //课程收藏
          addCourseFav(this.id).then(resp => {
            this.isFav = 1;
          });
        } else if (this.type == 2) {
          //新闻资讯收藏
          addNewsFav(this.id).then(resp => {
            this.isFav = 1;
          });
        } else if (this.type == 3) {
          //课程包收藏
          addCoursePkgFav(this.id).then(resp => {
            this.isFav = 1;
          });
        }
      }else{
         if (this.type == 1) {
          //取消课程收藏
          deleteCourseFav(this.id).then(resp => {
            this.isFav = 0;
          });
        } else if (this.type == 2) {
          //删除新闻资讯收藏
          deleteNewsFav(this.id).then(resp => {
            this.isFav = 0;
          });
        } else if (this.type == 3) {
          //删除课程包收藏
          deleteCoursePkgFav(this.id).then(resp => {
            this.isFav = 0;
          });
        }
      }
    }
  },
  props: {
    isFav: Number, //是否收藏
    id: Number, //id
    type: Number //收藏类型 1=>课程,2=>资讯,3=>课程包
  }
};
</script>
<style lang="scss">
.fav-box {
  display: inline-block;
  font-size: 1.4em;
  cursor: pointer;
  color: #717171;
  .fav {
    margin-right: 10px;
  }
}
</style>